import React, { useEffect, useRef } from 'react';
import * as styles from '../styles/listSeparator.module.scss';

interface Props {
  id: number;
  pinnedElementId: number;
  title: string;
  renderCallback: (id: number, offsetTop: number) => void;
}

const ListSeparator: React.FC<Props> = ({
  id,
  pinnedElementId,
  title,
  renderCallback,
}) => {
  const listItemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const listItem = listItemRef.current;
    renderCallback(id, listItem!.offsetTop);
  }, [id, renderCallback]);

  const isPinned = id === pinnedElementId;

  const containerClass = isPinned ? styles.container_fixed : styles.container;

  return (
    <li className={containerClass} ref={listItemRef}>
      <div className={styles.title}>{title}</div>
    </li>
  );
};

export default ListSeparator;
